<template>
  <v-dialog :value="value" max-width="500" scrollable @input="$emit('input', $event)">
    <v-card v-if="aulaSelecionada" style="max-height: 60vh">
      <v-card-title>
        Detalhes da Aula
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="">
        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Metodologia
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <div>{{ aulaSelecionada.metodologia || "- - -" }}</div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aulaSelecionada: {
      type: Object,
      default: null,
    },
  },
};
</script>
